<template>
    <v-dialog content-class="app-notification-dialog dialog-xs" transition="dialog-bottom-transition" v-model="value.active" persistent>
        <v-card style="text-align: center">
            <v-progress-linear v-if="!value.header" style="margin-top: 0;" :color="value.color" :indeterminate="value.progress" :value="value.progress ? null : 100"></v-progress-linear>
            <v-toolbar v-if="value.header" style="flex: 0 0 auto;" dark :class="value.color">
                <v-btn icon @click.native="value.active = false" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ $t(value.title) }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text style="padding-top: 8px;">
                <h1 v-if="!value.header">
                    <template v-if="value.icon">
                        <v-icon large>{{ value.icon }}</v-icon>&nbsp;&nbsp;
                    </template>
                    <span v-html="$t(value.title)"></span>
                </h1>
                <v-btn v-if="typeof(value.cancellable)!=='undefined' && value.cancellable === true" @click.native="value.active = false" absolute fab left top color="white" flat style="color: #000!important; margin: 43px 0 0 -10px;">
                    <v-icon>close</v-icon>
                </v-btn>

                <p v-if="value.text" v-html="$t(value.text)"></p>
                <div style="padding-right: 16px;" :style="(typeof(value.text)==='undefined' || value.text.length===0) ? 'padding-top: 12px' : ''">
                    <v-btn v-for="btn in value.buttons" :key="btn.title" style="margin-bottom: 10px;" :style="typeof(btn.style !== 'undefined') ? btn.style:''" @click="btn.callback" @click.native="value.active = false">{{ btn.text }}</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data: function() {
        return ({
            value: {
                active: false,
            },
        });
    },
    created() {
        this.$bus.$on("app.showNotification", (params) => {
            this.showNotification(params);
        });
    },
    methods: {
        showNotification: function(params) {
            params.active = true;
            if (typeof (params.color) === "undefined") params.color = "info";
            if (typeof (params.buttons) === "undefined") {
                params.buttons = [{
                    text: this.$t("core.btn_ok"),
                    callback: function() {
                    },
                }];
            }
            if (typeof (params.title) === "undefined") {
                params.title = "";
                if (params.color === "error") params.title = this.$t("core.error");
                if (params.color === "warning") params.title = this.$t("core.warning");
            }
            if (typeof (params.text) === "undefined") params.text = "";
            if (typeof (params.header) === "undefined") params.header = false;
            if (typeof (params.progress) === "undefined") params.progress = false;
            this.value = Object.assign({}, params);
        },
    },
};
</script>
